import { render, staticRenderFns } from "./CartCardContent.vue?vue&type=template&id=038d37d9"
import script from "./CartCardContent.vue?vue&type=script&lang=js"
export * from "./CartCardContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports